<div  v-if="shouldRenderConfig" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary btn-tab" v-bind:class="activeClass()" 
    v-on:click="setActiveProductPartName(code)">
        {{name}}
    </button>
</div>